import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getCreatOrderData = async (params: object) => {
  return await POST({
    url: Api.getCreatOrderData,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getPayAgentList = async (params: object) => {
  return await GET({
    url: Api.getPayAgentList,
    params,
    // headers: {
    //   rpcType: 'dubbo',
    //   'Client-Id': 'iss_courier',
    //   'Content-Type': 'application/json'
    // },
    showError: false
  })
}

export const creatOrderData = async (params: object) => {
  return await POST({
    url: Api.creatOrderData,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getLevelInfo = async (params: object) => {
  return await GET({
    url: Api.getLevelInfo,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getGloryInfo = async (params: object) => {
  return await POST({
    url: Api.getGloryInfo,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getMemberInfo = async (params: object) => {
  return await GET({
    url: Api.getLevelInfo,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
